var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-pt-xl text-center"},[_c('p',{staticClass:"text-faded"},[_vm._v("Ressource leider nicht gefunden "),_c('strong',[_vm._v("(404)")])])])
}]

export { render, staticRenderFns }